import NoteEntity from '../entities/Note';

export type State = NoteEntity[];

const initialState: State = [];

const Note = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'SUCCESS_READ_NOTES_BY_GROUP':
      return [...state, ...action.notes].filter(
        (note, index, self) => self.map(n => n.id).indexOf(note.id) === index
      );

    case 'SUCCESS_READ_NOTES_DIFF':
      const notesChanged = state.map(note =>
        action.notes.map((m: NoteEntity) => m.id).includes(note.id)
          ? action.notes.find((m: NoteEntity) => m.id === note.id)
          : note
      );

      const notesToAdd = action.notes.filter(
        (note: NoteEntity) => !state.map(m => m.id).includes(note.id)
      );

      return [...notesChanged, ...notesToAdd];

    case 'SUCCESS_CREATE_NOTE':
      return [...state, action.note].filter(
        (note, index, self) => self.map(n => n.id).indexOf(note.id) === index
      );

    case 'SUCCESS_UPDATE_NOTE':
      return state.map(note => {
        return note.id === action.note.id ? action.note : note;
      });

    case 'SUCCESS_DESTROY_NOTE':
      return state.filter(note => note.id !== action.note.id);
  }

  return state;
};

export default Note;



// WEBPACK FOOTER //
// ./src/reducers/Note.ts